import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getProductList({
    page,
    q = '',
    sort_by = 'created_at desc',
    limit = '10',
    minPrice,
    maxPrice,
    status,
    available_stock,
  }) {
    const params = {
      cursor: page,
      limit,
      q,
      sort_by,
      min_base_price: minPrice,
      max_base_price: maxPrice,
      status: status,
      available_stock,
    };
    const url = '/products';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  getProductDetail(id) {
    return api.get(`/products/${id}`);
  },
  getProductReport() {
    const params = {};
    return api.get('products/product_reports', {
      params: omitBy(params, isNil),
    });
  },
  createProduct(payload) {
    return api.post(`/products`, { product: payload });
  },
  updateProduct(id, payload) {
    return api.put(`/products/${id}`, { product: payload });
  },
  hideProduct(id) {
    return api.delete(`/products/${id}`);
  },
  deleteProduct(id) {
    return api.delete(`/products/${id}/delete`);
  },
  restoreProduct(id) {
    return api.put(`/products/${id}/reactivate`);
  },
  getCategoryList(parentId) {
    if (parentId) {
      return api.get(
        `/products/categories?parent_id=${parentId}&status=active&`
      );
    } else {
      return api.get(`/products/categories?&status=active&`);
    }
  },
  getBrandList(category_id) {
    if (category_id) {
      return api.get(
        `/products/brands?category_id=${category_id}&status=active&`
      );
    } else {
      return api.get('/products/brands?&status=active&');
    }
  },
  addRelations(id, payload) {
    return api.post(`/products/${id}/add_relation`, payload);
  },

  bulkUpdateProduct(payload) {
    return api.post(`/products/bulk_update`, { products: payload });
  },

  bulkCreateProduct(payload) {
    return api.post('/products/bulk_create', { products: payload });
  },
  bulkDiscountProduct(payload) {
    return api.post('/products/bulk_discounts', { products: payload });
  },
};
